import { useGetBackProcedimentiIdEndoprocedimenti } from '@framework/api-client/api/backoffice/procedimenti/procedimenti.ts';
import {
  type ISelectInputProps,
  SelectInput,
} from '@framework/form/inputs/SelectInput.tsx';
import { useMemo } from 'react';
import { useCommunicationsContext } from '../../context/CommunicationsContext.tsx';

export interface ICommunicationSubprocedureSelectInputProps
  extends ISelectInputProps {
  name: string;
  placeholder?: string;
  size?: 'small' | 'middle' | 'large';
}

/**
 * Permette di scegliere l'ufficio per la comunicazione
 * all'endoprocedimento.
 */
export function CommunicationSubprocedureSelectInput(
  props: ICommunicationSubprocedureSelectInputProps,
) {
  const { name, size = 'middle', placeholder, ...others } = props;

  // Recupero l'id del procedimento dal contesto
  const { procedureId } = useCommunicationsContext();

  const { data: subprocedures, isLoading } =
    useGetBackProcedimentiIdEndoprocedimenti(procedureId!, {
      query: { enabled: procedureId != null },
    });

  const options = useMemo(() => {
    return (subprocedures?.data ?? []).map(subprocedure => ({
      // Costruisco la label con il nome del tipo di procedimento, il numero
      // e il nome dell'ufficio di avvio.
      label: `${subprocedure.tipologiaProcedimento?.nomeTipo ?? 'N/A'} N.${
        subprocedure.numero ?? ''
      } (${subprocedure.nomeUfficioAvvio ?? 'N/A'})`,
      value: subprocedure.id!,
    }));
  }, [subprocedures]);

  // Non mostro nulla se non ho l'id del procedimento. Più per fallback che
  // altro, dato che su Backoffice è sempre valorizzato.
  if (!procedureId) {
    return null;
  }

  return (
    <SelectInput
      {...others}
      size={size}
      popupMatchSelectWidth={false}
      placeholder={placeholder}
      name={name}
      allowClear
      showSearch
      loading={isLoading}
      options={options}
    />
  );
}
